import { HStack, Text } from "@chakra-ui/layout";
import { currency } from "@src/utils/formatters";

type SummaryLabelProps = {
  label: string;
  amount: number | undefined | null;
  size?: "sm" | "lg";
};
export const SummaryLabel = ({
  label,
  amount,
  size = "sm",
}: SummaryLabelProps) => {
  return (
    <HStack
      justify="space-between"
      mt="0.5"
      textColor={size === "sm" ? "gray.500" : undefined}
      fontSize={size}
      fontWeight={size === "sm" ? "normal" : "bold"}
    >
      <Text fontWeight="inherit">{label}</Text>
      <Text fontWeight="inherit">
        {currency.formatByWorkspace(amount ?? 0)}
      </Text>
    </HStack>
  );
};
